<template>
	<div>
		<b-row class="mb-2">
			<b-col>
				<!-- begin breadcrumb -->
				<!--
				<ol class="breadcrumb float-xl-right">
					<li class="breadcrumb-item active"><a href="javascript:;">Home</a></li>
				</ol>
				-->
				<!-- end breadcrumb -->
				<!-- begin page-header -->
				<h1 class="page-header">{{ $t('home_header_name') }} <!--<small class="ml-2">{{ this.$t('home_header_small_text') }}</small>--></h1>
				<!-- end page-header -->
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<page-content-container>
					<router-view 
						:user="user"
						:checkRole="checkRole"
					/>
				</page-content-container>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import PageContentContainer from '../components/shared/PageContentContainer'

export default {
    name: 'Home',
	components: {
		PageContentContainer,
	},
    props: [
		'checkRole',
		'user',
	],
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
    },
}
</script>
